import { useState } from 'react';
import './../css/review.css';
import { FaStar } from "react-icons/fa";
import FormInput from './input_form';

const WriteReview = () => {


    const [Fname, setFname] = useState("");
    const [Lname, setLname] = useState("");
    const [Email, setEmail] = useState("");
    const [Phone, setPhone] = useState("");
    const [Message, setMessage] = useState("");
    const [Rate, setRate] = useState(1);
    
    const reviewForm = [
        {
            name: "Fname",
            type: "text",
            placeholder: "First Name",
            label: "First Name",
            store: setFname,
            span: "First name should be 3-16 characters",
            pattern: "^[A-Za-z]{3,16}$",
            required: true
        },
        {
            name: "Lname",
            type: "text",
            placeholder: "Last Name",
            label: "Last Name",
            store: setLname,
            span: "Last name should be 3-16 characters",
            pattern: "^[A-Za-z]{3,16}$",
            required: true
        },
        {
            name: "email",
            type: "email",
            placeholder: "Email",
            label: "Conatct Email",
            store: setEmail,
            span:  "Invalid Email",
            required: true
        },
        {
            name: "phone",
            type: "text",
            placeholder: "Phone Number",
            label: "Contact Phone",
            store: setPhone,
            span: "Phone number should be 9-11 number NO +64 REQUIRED",
            pattern: "^[0-9]{9,11}$",
            required: true
        },


    ]
    const handleSubmit = (e: { preventDefault: () => void; }) => {
        e.preventDefault();

        const data: sendReview = {  fname:Fname, 
                                    lname:Lname, 
                                    email:Email,
                                    phone: parseInt(Phone),
                                    message:Message,
                                    rate: Rate
                                    }

        // AXIOS STUFF GOES HERE
        console.log(data);
        

        // Close 
        

    }

    return (
        <form className="review_popup" onSubmit={handleSubmit}>
            <h2>Send us your thought on our service.</h2>
            <div className='review_popup_star'>
                <button className={Rate >= 1 ? 'active_rate' : 'deactive_rate' } onClick={()=> setRate(1)}><FaStar/></button>
                <button className={Rate >= 2 ? 'active_rate' : 'deactive_rate' } onClick={()=> setRate(2)}><FaStar/></button>
                <button className={Rate >= 3 ? 'active_rate' : 'deactive_rate' } onClick={()=> setRate(3)}><FaStar/></button>
                <button className={Rate >= 4 ? 'active_rate' : 'deactive_rate' } onClick={()=> setRate(4)}><FaStar/></button>
                <button className={Rate >= 5 ? 'active_rate' : 'deactive_rate' } onClick={()=> setRate(5)}><FaStar/></button>
            </div>
            <div className='review_popup_input'>
                {reviewForm.map((input) => (
                    <FormInput 
                    name={input.name}
                    type={input.type}
                    placeholder={input.placeholder}
                    label={input.label}
                    setValue={input.store}
                    span={input.span}
                    required={input.required}
                    pattern={input.pattern}
                /> 
                ))}
            </div>
            <textarea placeholder='Hi, it was my first tattoo and they were really nice.'required onChange={e => setMessage(e.target.value)} />

            <input type="submit" value="Submit" className="submit-btn" style={{ width: 45 +'%' }} ></input>


        </form>
    )

};


export default WriteReview;